import { GalimardIngredient } from "./GalimardIngredient";

export const GalimardNoteDeFond: GalimardIngredient[] = [
  {
    name: "ACCORD MUSC",
    displayName: {
      fr: "Accord Musc",
      en: "",
    },
    galimardReference: "705",
    description: {
      fr: "Un accord de muscs propres et veloutés, à l’effet seconde peau. En fond, il arrondit la composition et prolonge discrètement le sillage.",
      en: "A blend of clean, velvety musks with a second-skin effect. In the base, it rounds out the composition and quietly extends the trail.",
    },
    icon: "accord-musc",
  },
  {
    name: "AMANDE",
    galimardReference: "900",
    description: {
      fr: "L’amande gourmande, entre pâte d’amande et noyau de cerise, douce et légèrement poudrée. Elle tapisse le fond d’une chaleur sucrée et rassurante.",
      en: "Gourmand almond, between marzipan and cherry pit, sweet and lightly powdery. It lines the base with a sweet, reassuring warmth.",
    },
    icon: "amande",
  },
  {
    name: "AMBRE",
    galimardReference: "650",
    description: {
      fr: "L’accord ambré classique, chaud, résineux et vanillé, légèrement poudré. Il enveloppe la composition et lui assure une belle tenue.",
      en: "The classic amber accord, warm, resinous and vanilla-tinged, slightly powdery. It wraps the composition and helps it last.",
    },
    // prompt: "small amber rocks on a small wooden plank, detailed, white background"
    icon: "ambre",
  },
  {
    name: "AMBRE ORIENTAL",
    galimardReference: "247",
    description: {
      fr: "Un ambre plus riche, relevé d’épices et de notes d’encens, chaud et résineux. Il laisse en fond un sillage profond et voluptueux.",
      en: "A richer amber, spiced and touched with incense, warm and resinous. It leaves a deep, voluptuous trail in the base.",
    },
    // prompt: "a few amber rocks with burning incense sticks on a small wooden plank, detailed, white background"
    icon: "ambre-oriental",
  },
  {
    name: "AMBRE VERT",
    galimardReference: "652",
    description: {
      fr: "Un ambre chaud et résineux, rafraîchi par des facettes vertes, herbacées et moussues. Il donne au fond une chaleur plus sèche et aromatique.",
      en: "A warm, resinous amber freshened by green, herbal and mossy facets. It gives the base a drier, more aromatic warmth.",
    },
    // prompt: "a few small amber rocks and wood moss on a small wooden plank, detailed, white background"
    icon: "ambre-vert",
  },
  {
    name: "AMBREINE",
    displayName: {
      fr: "Ambréine",
      en: "",
    },
    galimardReference: "653",
    description: {
      fr: "Une note inspirée de l’ambre gris, chaude, musquée et légèrement salée, comme une peau au soleil. En fond, elle laisse un sillage doux et diffusant.",
      en: "A note inspired by ambergris, warm, musky and slightly salty, like sun-warmed skin. In the base, it leaves a soft, radiant trail.",
    },
    icon: "ambreine",
  },
  {
    name: "BARBAPAPA",
    displayName: {
      fr: "Barbe à papa",
      en: "Cotton candy",
    },
    galimardReference: "948",
    description: {
      fr: "La barbe à papa des fêtes foraines, sucre filé, caramel léger et touche vanillée. Elle laisse sur la peau une douceur gourmande qui rappelle l’enfance.",
      en: "Fairground cotton candy: spun sugar, light caramel and a touch of vanilla. It leaves a gourmand sweetness on the skin that recalls childhood.",
    },
    icon: "unknown-ingredient",
  },
  {
    name: "BOIS AMBRE",
    displayName: {
      fr: "Bois Ambré",
      en: "",
    },
    galimardReference: "654",
    description: {
      fr: "Des bois secs réchauffés par une chaleur ambrée, puissants et rayonnants. Ce fond donne du relief, de la tenue et un sillage affirmé.",
      en: "Dry woods warmed by an ambery glow, strong and radiant. This base adds depth, staying power and a confident trail.",
    },
    icon: "bois-ambre",
  },
  {
    name: "BOIS DE SANTAL",
    displayName: {
      fr: "Bois de Santal",
      en: "",
    },
    galimardReference: "655",
    description: {
      fr: "Le bois de santal, crémeux, lacté et doucement boisé. Sa chaleur enveloppante retient les notes plus légères et prolonge le parfum.",
      en: "Sandalwood, creamy, milky and softly woody. Its enveloping warmth holds on to the lighter notes and extends the perfume.",
    },
    icon: "bois-de-santal",
  },
  {
    name: "COMPLEXE BOISE",
    displayName: {
      fr: "Complexe Boisé",
      en: "",
    },
    galimardReference: "661",
    description: {
      fr: "Un assemblage de plusieurs bois, secs et chauds, pour un fond boisé complet et équilibré. Il structure la composition et prolonge sa tenue.",
      en: "A blend of several woods, dry and warm, for a full, balanced woody base. It gives the composition structure and helps it last.",
    },
    icon: "complexe-boise",
  },
  {
    name: "BOIS ET TONKA",
    displayName: {
      fr: "bois et Tonka",
      en: "",
    },
    galimardReference: "723",
    description: {
      fr: "Des bois chauds adoucis par la fève tonka, aux accents d’amande, de foin et de caramel. Un fond boisé et gourmand, doux et rond.",
      en: "Warm woods softened by tonka bean, with hints of almond, hay and caramel. A woody, gourmand base, soft and round.",
    },
    icon: "bois-et-tonka",
  },
  {
    name: "BOIS MOUSSE",
    galimardReference: "656",
    description: {
      fr: "Des bois mêlés de mousses, terreux, légèrement fumés, avec une fraîcheur humide. Ce fond donne de la profondeur et un caractère sobre et distingué.",
      en: "Woods blended with mosses, earthy, slightly smoky, with a damp freshness. This base adds depth and a sober, distinguished character.",
    },
    icon: "bois-mousse",
  },
  {
    name: "BOISE CEDRE",
    displayName: {
      fr: "Boisé cèdre",
      en: "",
    },
    galimardReference: "659",
    description: {
      fr: "Le bois de cèdre, sec et net, qui rappelle les copeaux d’un crayon fraîchement taillé. Il dessine en fond une structure boisée claire et droite.",
      en: "Cedarwood, dry and clean, recalling freshly sharpened pencil shavings. It draws a clear, upright woody structure in the base.",
    },
    icon: "boise-cedre",
  },
  {
    name: "BOUQUET BOISE",
    displayName: {
      fr: "Bouquet Boisé",
      en: "",
    },
    galimardReference: "706",
    description: {
      fr: "Un bouquet de bois clairs, relevé d’une touche florale et aromatique. Ce fond boisé reste léger et harmonieux.",
      en: "A bouquet of light woods, lifted by a floral, aromatic touch. A woody base that stays light and harmonious.",
    },
    // prompt: "bouquet boisé lying down, top view, detailed, white background"
    icon: "bouquet-boise",
  },
  {
    name: "CHOCOLAT",
    displayName: {
      fr: "Chocolat",
      en: "",
    },
    galimardReference: "",
    description: {
      fr: "Le cacao, gourmand et légèrement amer, entre chocolat noir et poudre de cacao. Il signe le fond d’une douceur profonde, à la fois sucrée et sombre.",
      en: "Cocoa, gourmand and slightly bitter, between dark chocolate and cocoa powder. It marks the base with a deep sweetness, at once sugary and dark.",
    },
    icon: "chocolat",
  },
  // {
  //   name: "CONCRETAL",
  //   displayName: {
  //     fr: "Contrétal",
  //     en: "",
  //   },
  //   galimardReference: "477",
  //   // icon: "concretal",
  // },
  {
    name: "CUIR",
    galimardReference: "458",
    description: {
      fr: "L’odeur d’un cuir souple, à la fois fumé, sec et légèrement animal. Clin d’œil aux gantiers de Grasse, il donne au fond un caractère fort.",
      en: "The smell of supple leather, smoky, dry and slightly animalic. A nod to the glove-makers of Grasse, it gives the base strong character.",
    },
    // prompt: "leather gloves on top on each other on a small table with a ancien perfume spray, detailed, white background"
    icon: "cuir",
  },
  {
    name: "ECORCE",
    displayName: {
      fr: "Écorce",
      en: "",
    },
    galimardReference: "707",
    description: {
      fr: "L’écorce des arbres, sèche, boisée et légèrement fumée, avec une pointe résineuse. En fond, elle évoque une promenade en forêt et apporte une texture brute.",
      en: "Tree bark, dry, woody and slightly smoky, with a resinous edge. In the base, it recalls a walk in the woods and adds a raw texture.",
    },
    icon: "ecorce",
  },
  {
    name: "FEVE TONKA",
    displayName: {
      fr: "Fève Tonka",
      en: "",
    },
    galimardReference: "662",
    description: {
      fr: "La fève tonka, entre amande, foin séché, caramel et vanille, avec une nuance de tabac. Elle apporte au fond une douceur chaude et ronde.",
      en: "Tonka bean, somewhere between almond, dry hay, caramel and vanilla, with a hint of tobacco. It brings a warm, round sweetness to the base.",
    },
    // prompt: "longues fève noires ridée on a small wooden plank, detailed, white background"
    icon: "feve-tonka",
  },
  {
    name: "FLEUR DE MUGUET",
    displayName: {
      fr: "Fleur de muguet",
      en: "",
    },
    galimardReference: "708",
    description: {
      fr: "Le muguet en note de fond, adouci par des notes musquées et poudrées. Plus tendre et plus tenace que la fleur fraîche, il prolonge le bouquet dans le sillage.",
      en: "Lily of the valley as a base note, softened by musky, powdery notes. Gentler and longer-lasting than the fresh flower, it carries the bouquet into the trail.",
    },
    // prompt: "bouquet of lily of the valley in bloom lying down, top view, detailed, white background"
    icon: "fleur-de-muguet",
  },
  {
    name: "FRUITS SECS",
    galimardReference: "710",
    description: {
      fr: "Un mélange gourmand de fruits séchés et de noix, chaud, sucré et légèrement boisé. En fond, sa douceur automnale reste plus discrète qu’une praline.",
      en: "A gourmand mix of dried fruit and nuts, warm, sweet and slightly woody. In the base, its autumnal sweetness stays subtler than praline.",
    },
    // prompt: "dried fruit  on a small wooden plank, detailed, white background"
    icon: "fruits-secs",
  },
  {
    name: "IRIS",
    galimardReference: "663",
    description: {
      fr: "L’iris, poudré, beurré et légèrement boisé, avec une nuance de violette. Il prolonge le parfum d’un sillage poudré, doux et raffiné.",
      en: "Iris, powdery, buttery and slightly woody, with a hint of violet. It extends the perfume with a soft, refined powdery trail.",
    },
    icon: "iris",
  },
  {
    name: "LICHEN",
    galimardReference: "664",
    description: {
      fr: "Le lichen qui couvre les rochers et les troncs, terreux, minéral et légèrement iodé. Il apporte une profondeur sauvage, comme un sentier de montagne.",
      en: "The lichen that covers rocks and tree trunks, earthy, mineral and slightly salty. It brings a wild depth, like a mountain path.",
    },
    // prompt: "lichen on a granite rock, detailed, white background"
    icon: "lichen",
  },
  {
    name: "LILAS",
    galimardReference: "665",
    description: {
      fr: "Un lilas poudré et doucement amandé, travaillé pour durer. En fond, il prolonge les notes florales dans un sillage tendre et nostalgique.",
      en: "A powdery lilac with a soft almond nuance, made to last. In the base, it carries the florals into a tender, nostalgic trail.",
    },
    // prompt: "bouquet of lila lying down, top view, detailed, white background"
    icon: "lilas",
  },
  {
    name: "MOUSSE",
    galimardReference: "711",
    description: {
      fr: "Une mousse douce et veloutée, verte et légèrement poudrée, comme un tapis de forêt. Elle apporte une fraîcheur boisée discrète et durable.",
      en: "A soft, velvety moss, green and lightly powdery, like a forest carpet. It brings a discreet, lasting woody freshness.",
    },
    icon: "mousse",
  },
  {
    name: "MOUSSE D'ARBRE",
    displayName: {
      fr: "Mousse d'arbre",
      en: "",
    },
    galimardReference: "712",
    description: {
      fr: "La mousse qui pousse sur les branches des arbres, boisée, résineuse et légèrement fumée. Elle apporte une profondeur sombre aux accords boisés et cuirés.",
      en: "The moss that grows on tree branches, woody, resinous and slightly smoky. It lends a dark depth to woody and leathery blends.",
    },
    // prompt: "tree moss on a trunk detailed, white background"
    icon: "mousse-arbre",
  },
  {
    name: "MOUSSE DE BAVIERE",
    displayName: {
      fr: "Mousse de Bavière",
      en: "",
    },
    galimardReference: "478",
    description: {
      fr: "Une mousse dense des forêts de montagne, humide, terreuse et un peu cuirée. En fond, elle donne une assise sombre et puissante.",
      en: "A dense moss from mountain forests, damp, earthy and slightly leathery. In the base, it provides a dark, powerful foundation.",
    },
    // tree moss in Bavaria on a trunk detailed, white background
    icon: "mousse-de-baviere",
  },
  {
    name: "MOUSSE VERTE",
    galimardReference: "713",
    description: {
      fr: "Une mousse fraîche et très verte, comme un rocher moussu au bord d’un ruisseau. Elle garde au fond une fraîcheur humide et végétale.",
      en: "A fresh, very green moss, like a mossy rock beside a stream. It keeps a damp, leafy freshness in the base.",
    },
    // prompt: "close-up of a rock covered with green moss"
    icon: "mousse-verte",
  },
  {
    name: "MUSC",
    // prompt: "happy musk deer, ears pointing up, detailed, white background"
    galimardReference: "666",
    description: {
      fr: "Un musc chaud et sensuel, proche de l’odeur de la peau, avec une légère facette animale. Il lie les notes entre elles et laisse un sillage intime.",
      en: "A warm, sensual musk, close to the scent of skin, with a slight animalic facet. It ties the notes together and leaves an intimate trail.",
    },
    icon: "musc",
  },
  {
    name: "MUSC BLANC",
    galimardReference: "715",
    description: {
      fr: "Le musc blanc, propre et cotonneux, qui évoque le linge frais sorti de la machine. Il pose sur la peau une douceur légère et lumineuse.",
      en: "White musk, clean and cottony, recalling freshly washed laundry. It lays a light, luminous softness on the skin.",
    },
    // prompt: "musk deer walking in the forest, a sheet is drying in the background, clean, detailed, white background"
    icon: "musc-blanc",
  },
  {
    name: "MUSC DOUX",
    // prompt: "happy musk deer without wood, detailed, white background"
    galimardReference: "667",
    description: {
      fr: "Un musc tendre et légèrement sucré, poudré comme une caresse. Il enveloppe la composition d’une douceur câline.",
      en: "A tender, slightly sweet musk, powdery like a caress. It wraps the composition in a cozy softness.",
    },
    icon: "musc-doux",
  },
  {
    name: "MUSC FLORAL",
    // prompt: "musk deer, walking on flowers, detailed, white background"
    galimardReference: "668",
    description: {
      fr: "Un musc soyeux auréolé de fleurs, entre propreté et douceur poudrée. Il prolonge le bouquet floral dans un sillage délicat.",
      en: "A silky musk with a halo of flowers, both clean and softly powdery. It carries the floral bouquet into a delicate trail.",
    },
    icon: "musc-floral",
  },
  {
    name: "NOTE PRALINE",
    galimardReference: "504",
    description: {
      fr: "Des amandes grillées enrobées de sucre caramélisé, chaudes et gourmandes. La note praline nappe le fond d’une douceur généreuse.",
      en: "Toasted almonds coated in caramelized sugar, warm and gourmand. Praline blankets the base in a generous, comforting sweetness.",
    },
    // prompt: "bowl of brown pralines shaped as almonds in cooked sugar placed on a small wooden plank, detailed, white background"
    icon: "note-praline",
  },
  {
    name: "NOTE CASTOREUM",
    galimardReference: "669",
    description: {
      fr: "Une note animale, cuirée et fumée, qui rappelle le goudron de bouleau, avec une touche sucrée. À très petite dose, elle donne de la profondeur aux cuirs et aux bois.",
      en: "An animalic note, leathery and smoky, recalling birch tar, with a touch of sweetness. In very small doses, it adds depth to leathers and woods.",
    },
    // icon: "note castoreum",
  },
  {
    name: "VETIVER",
    galimardReference: "675",
    description: {
      fr: "Le vétiver, boisé, terreux et légèrement fumé, avec une fraîcheur d’herbe sèche. Il structure le fond avec une élégance sèche et racée.",
      en: "Vetiver, woody, earthy and slightly smoky, with the freshness of dry grass. It structures the base with a dry, refined elegance.",
    },
    displayName: {
      fr: "Vétiver",
      en: "",
    },
    // prompt: "Vetivergras, detailed, white background"
    icon: "vetiver",
  },
  {
    name: "SOUS BOIS",
    galimardReference: "719",
    description: {
      fr: "L’odeur du sous-bois en automne, terre humide, feuilles mortes, mousse et champignon. Ce fond apporte une profondeur sombre et mystérieuse.",
      en: "The smell of the forest floor in autumn: damp earth, fallen leaves, moss and mushroom. This base brings a dark, mysterious depth.",
    },
    icon: "sous-bois",
  },
  {
    name: "RACINES DE VETIVER",
    displayName: {
      fr: "Racines de Vétiver",
      en: "",
    },
    galimardReference: "716",
    description: {
      fr: "Le vétiver côté racines, plus terreux, plus fumé et plus sombre. Un fond au caractère brut, d’une grande profondeur.",
      en: "Vetiver at its rootiest, earthier, smokier and darker. A base with raw character and great depth.",
    },
    // prompt: "vetiver with it's roots, detailed, white background"
    icon: "racines-de-vetiver",
  },
  {
    name: "PATCHOULI",
    galimardReference: "390",
    description: {
      fr: "Le patchouli, terreux, boisé et un peu camphré, avec une facette sombre presque chocolatée. Il donne au fond une présence affirmée et durable.",
      en: "Patchouli, earthy, woody and a little camphor-like, with a dark, almost chocolatey facet. It gives the base a bold, lasting presence.",
    },
    // prompt: "patchouli, detailed, white background"
    icon: "patchouli",
  },
  {
    name: "OUD",
    galimardReference: "???",
    description: {
      fr: "Le oud, bois précieux d’Asie très prisé au Moyen-Orient, est boisé et fumé, avec des accents de cuir. En fond, il apporte une intensité sombre et opulente.",
      en: "Oud, a precious Asian wood prized in the Middle East, is woody and smoky, with leathery accents. In the base, it brings a dark, opulent intensity.",
    },
    advice: ``,
    icon: "oud",
  },
  {
    name: "OPOPONAX",
    galimardReference: "806",
    description: {
      fr: "Une résine douce et balsamique, cousine de la myrrhe, aux accents miellés et légèrement poudrés. Elle réchauffe le fond d’une douceur ambrée et veloutée.",
      en: "A sweet, balsamic resin, a cousin of myrrh, with honeyed, slightly powdery accents. It warms the base with a velvety, ambery softness.",
    },
    icon: "opoponax",
  },
  {
    name: "SANTAL",
    galimardReference: "671",
    description: {
      fr: "Un santal boisé et velouté, à la douceur sèche et légèrement épicée. Sa chaleur discrète s’accorde aussi bien aux notes fraîches qu’aux fleurs.",
      en: "A woody, velvety sandalwood with a dry, slightly spicy softness. Its quiet warmth suits fresh notes and florals alike.",
    },
    icon: "santal",
  },
  {
    name: "SANTAL EXOTIQUE",
    galimardReference: "717",
    description: {
      fr: "Un santal crémeux réchauffé d’accents solaires et épicés, qui évoque les bois des pays lointains. Sa chaleur douce et dépaysante s’attarde sur la peau.",
      en: "A creamy sandalwood warmed by sunny, spicy accents, evoking woods from faraway lands. Its soft, transporting warmth lingers on the skin.",
    },
    icon: "santal-exotique",
  },
  {
    name: "SANTAL ORIENT",
    displayName: {
      fr: "Santal d'Orient",
      en: "",
    },
    galimardReference: "672",
    description: {
      fr: "Un santal profond, réchauffé par des notes ambrées et épicées. En fond, il laisse un sillage chaud et sensuel, qui s’accorde au oud et à la rose.",
      en: "A deep sandalwood, warmed by ambery, spicy notes. In the base, it leaves a warm, sensual trail that pairs well with oud and rose.",
    },
    icon: "santal-orient",
  },
  {
    name: "SANTALINE",
    galimardReference: "718",
    description: {
      fr: "Une note de santal légère et lactée, douce et légèrement sucrée. Elle apporte au fond une rondeur boisée subtile, sans lourdeur.",
      en: "A light, milky sandalwood note, soft and slightly sweet. It adds a subtle woody roundness to the base without heaviness.",
    },
    icon: "santaline",
  },
  {
    name: "TUBEREUSE",
    displayName: {
      fr: "Tubéreuse",
      en: "",
    },
    galimardReference: "720",
    description: {
      fr: "La tubéreuse, fleur blanche capiteuse, crémeuse et un peu beurrée, à la sensualité intense. En note de fond, elle prolonge longtemps un sillage floral opulent.",
      en: "Tuberose, a heady white flower, creamy and slightly buttery, with an intense sensuality. As a base note, it carries an opulent floral trail for a long time.",
    },
    icon: "tubereuse",
  },
  {
    name: "VANILLE",
    galimardReference: "198",
    description: {
      fr: "La vanille, chaude, sucrée et légèrement boisée, aux accents de gousse et de crème. Elle arrondit la composition et adoucit les bois et les épices.",
      en: "Vanilla, warm, sweet and slightly woody, with hints of the pod and of cream. It rounds out the composition and softens woods and spices.",
    },
    icon: "vanille",
  },
  {
    name: "CEDRE EBENE",
    displayName: {
      fr: "Cèdre ébène",
      en: "",
    },
    galimardReference: "???",
    description: {
      fr: "Un cèdre sec assombri par des bois noirs, légèrement fumés et cuirés. Il bâtit un fond boisé intense, au sillage profond.",
      en: "A dry cedar darkened by black woods, slightly smoky and leathery. It builds an intense woody base with a deep trail.",
    },
    icon: "cedre-ebene",
  },
  {
    name: "CAFE",
    displayName: {
      fr: "Café",
      en: "Coffee",
    },
    galimardReference: "969",
    description: {
      fr: "L’arôme du café fraîchement torréfié, grillé, légèrement amer et chaleureux. Pour un fond gourmand, intense et un peu sombre.",
      en: "The aroma of freshly roasted coffee, toasty, slightly bitter and warm. For an intense, slightly dark gourmand base.",
    },
    icon: "cafe",
  },
];
